
// 必須data定義
//  grid: {
//    cellH:    0, // セル幅
//    cellW:    0, // セル高さ
//    headerW:  0, // ヘッダ幅
//    headerH:  0, // ヘッダ高さ
//    paddingW: 0, // テーブル右端余白サイズ
//    paddingH: 0, // テーブル下端余白サイズ
//  },

import GridColumns    from './GridColumns'
import GridRows       from './GridRows'
import GridRowBorders from './GridRowBorders'
import GridCells      from './GridCells'

import 'mixins/GridMixin.sass'

const GridBaseMixin = {
  components: {GridColumns, GridRows, GridRowBorders, GridCells},

  computed: {
    // .grid__table(:style="gridTableStyle")
    gridTableStyle() {
      return {
        paddingRight: this.grid.paddingW + 'px',
        paddingBottom: this.grid.paddingH + 'px',
      }
    },

    // .grid__corner(:style="gridCornerStyle")
    gridCornerStyle() {
      return {
        width: this.grid.headerW + 'px',
        height: this.grid.headerH + 'px',
      }
    },

    // .grid__column-header(:style="gridColumnHeaderStyle")
    gridColumnHeaderStyle() {
      return {
        width: this.grid.cellW + 'px',
        height: this.grid.headerH + 'px',
      }
    },

    // .grid__row-header(:style="gridRowHeaderStyle")
    gridRowHeaderStyle() {
      return {
        width: this.grid.headerW + 'px',
        height: this.grid.cellH + 'px',
      }
    },

    // .grid__cell(:style="gridCellStyle")
    gridCellStyle() {
      return {
        width: this.grid.cellW + 'px',
        height: this.grid.cellH + 'px',
      }
    },
  },

  methods: {

    // マウスイベントからセル位置を取得する
    getCellPosition(e) {
      const rect = this.$refs.table.getBoundingClientRect()
      return {
        x: Math.floor((e.clientX - rect.left - this.grid.headerW) / this.grid.cellW),
        y: Math.floor((e.clientY - rect.top  - this.grid.headerH) / this.grid.cellH),
      }
    },

    // フォーカス状態を取得する
    // TODO: chrome,IE11で使えているが、
    // TODO: firefox,safariでQuasarのドロワーメニュー展開時のみ検出に問題あり
    isFocused() {
      return document.hasFocus() &&
            document.activeElement !== null &&
            document.activeElement !== document.body &&
            document.activeElement !== document.documentElement
    },
  },
}

export default GridBaseMixin
